module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in-left/wow-fade-in-left.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in-left/wow-fade-in-left.component.scss
// module chunks = main